import React from 'react';
import { filter, orderBy } from 'lodash';
import enhance from './CompanyPaymentSettings.enhancer';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import AddCompanyBalance from './AddCompanyBalance';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';

class CompanyPaymentSettings extends React.Component {
  constructor() {
    super();

    const initialState = {
      index: 0,
      value: 0,
      isWithdrawFundsDialogOpen: false,
      isDepositFundsDialogOpen: false,
      isLoadingFinancials: false
    };

    this.state = {
      ...initialState
    };
  }

  onGetCompanyFinancesComplete = () => {
    this.setState({
      isLoadingFinancials: false
    });
  };

  componentWillMount() {
    if (this.props.finances.currentBalance == null) {
      this.setState({
        isLoadingFinancials: true
      });
      this.props.getCompanyFinances(this.onGetCompanyFinancesComplete);
    }
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
      index: newValue
    });
  };

  closeAddFundsDialog() {
    this.setState({
      isDepositFundsDialogOpen: false
    });
  }

  openAddFundsDialog() {
    this.setState({
      isDepositFundsDialogOpen: true
    });
  }

  render() {
    const { isLoadingFinancials, isDepositFundsDialogOpen } = this.state;

    const { classes, finances } = this.props;

    return (
      <React.Fragment>
        <Grid container direction="column">
          <Grid item align="center">
            <Typography variant="h2" className={classes.currentBalance}>
              $
              {finances.currentBalance
                ? finances.currentBalance.toLocaleString()
                : 0}
            </Typography>
            <Typography>Current Balance</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          className={classes.fundsButtonContainer}
          style={{ width: '100%' }}
          align="center"
        >
          <Button
            className={classes.addFundsButton}
            onClick={this.openAddFundsDialog.bind(this)}
          >
            Add Funds
          </Button>
        </Grid>
        <Grid item style={{ width: '100%' }} align="center">
          <div className={classes.dealsTable}>
            <Table className={classes.table}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.headerCell}>
                    Timestamp
                  </TableCell>
                  <TableCell className={classes.headerCell}>Type</TableCell>
                  <TableCell className={classes.headerCell}>Amount</TableCell>
                  <TableCell className={classes.headerCell}>
                    New Balance
                  </TableCell>
                </TableRow>
                {finances &&
                  finances.balanceHistory &&
                  finances.balanceHistory.length > 0 &&
                  finances.balanceHistory.map((historyRecord, index) => (
                    <TableRow key={index} className={classes.tableRow}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tableCell}
                      >
                        {historyRecord.timestamp
                          ? moment(historyRecord.timestamp).format('MM/DD/YYYY')
                          : ''}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tableCell}
                      >
                        {historyRecord.type}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tableCell}
                      >
                        {historyRecord.amount}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tableCell}
                      >
                        {historyRecord.newCurrentBalance}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </Grid>
        <AddCompanyBalance
          isOpen={isDepositFundsDialogOpen}
          onCloseDialog={this.closeAddFundsDialog.bind(this)}
        />
        {isLoadingFinancials && (
          <div className={classes.loadingOverlay}>
            <CircularProgress className={classes.loadingSpinner} />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default enhance(CompanyPaymentSettings);



// WEBPACK FOOTER //
// ./src/components/company/settings/payments/CompanyPaymentSettings.js